export const logSecurityEvent = async (userId, action, description) => {
    const supabase = useSupabaseClient()
    await supabase.from('security_logs').insert([{ user_id: userId, action, description }])
}
